<mat-icon [svgIcon]="name" [color]="color"></mat-icon>
